var lastScrollTop = 0;

window.addEventListener("scroll", function () {
  const st = window.pageYOffset || document.documentElement.scrollTop;
  const header = document.querySelector('.header-group');
  const body = document.body;

  if (!header) return;

  const scrollingDown = st > lastScrollTop;
  const scrollingUp = st < lastScrollTop;
  const isMobile = window.innerWidth <= 1280; // Puedes ajustar el breakpoint

  // ==== MOBILE ONLY ====
  if (isMobile) {
    if (scrollingDown) {
      if (header.classList.contains('active')) {
        header.classList.add('deactive');
         setTimeout(() => {
          header.classList.remove('active');
          header.classList.remove('deactive');
        }, 500);
      } 
      body.classList.add('sticky-mobile'); // 👈 agregar cuando baja
    } else if (scrollingUp) {
      header.classList.add('active');
      body.classList.remove('sticky-mobile'); // 👈 remover cuando sube
    }
  }

  // ==== DESKTOP ALWAYS ====
  if (st === 0) {
    header.classList.remove('active_desktop');
    body.classList.remove('sticky'); // 👈 quitar sticky al llegar arriba
  } else if (st > 40) {
    header.classList.add('active_desktop');
    body.classList.add('sticky'); // 👈 agregar sticky al hacer scroll
  }

  lastScrollTop = st <= 0 ? 0 : st;
}, false);


